export default (WrappedComponent) => {
    const MockTranslation = ({ trls = {}, ...props }) => {
        // eslint-disable-next-line no-restricted-syntax
        const trlProxy = new Proxy(trls, {
            get(target, name) {
                if (typeof name !== 'string' || name === '_isMockFunction') {
                    return target[name];
                }
                return target[name] || name;
            },
        });

        return <WrappedComponent {...props} trls={trlProxy} />;
    };

    return MockTranslation;
};
